module.exports = __webpack_public_path__ + "static/img/global-car.4f5a9ad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/global-car.jpg
// module id = Y96T
// module chunks = 4